export const CONFIRM_EMPTY_RESCAN = (
    <>
        Are you sure you want to <strong>delete</strong> the contents of the <strong>Rescan</strong> folder?
    </>
);
export const PLEASE_SELECT = 'Please Select';
export const INDEXED = 'currently being indexed';
export const SOFT_LOCKED = 'soft-locked';
export const HARD_LOCKED = 'hard-locked';
export const IsWorkingDocumentStatus = 1;
export const TODO_LIST_INDEXONLY1DOC_MSG = 'Document will remain locked, unable to continue Indexing.';
export const TODO_LIST_GroupSubject = 'CS2 Documate Group';
export const TODO_LIST_UsersDropDown_UnAssigned = 'Unassigned';
export const TODO_LIST_UsersDropDown_UnAssignedId = '00000000-0000-0000-0000-000000000000';
export const TODO_LIST_UsersDropDown_All = 'All';
export const TODO_LIST_UsersDropDown_AllValue = 'allUsers';
export const Indexing_Delete_Close_Field = 'Delete';
export const Parked_SALES = '4F98CFE2-25C1-4460-95C4-3B8D314DC6E0';
export const Parked_CS = '7F05CC1A-63CF-4910-9B9D-EA47D62C2430';
export const Parked_CP = 'E11A99CB-9F2D-437F-B6E8-9602CB34A4DB';
export const TODO_LIST_FolderParked_Field = 'Parked';
export const DocuMateIndexingSubject = 'Indexing and Processing';
export const BulkAction_Field = 'Documate Todo Bulk Action';
export const BULK_DELETE_CONFIRM_TITLE = 'Confirm Bulk Delete';
export const BULK_DELETE_CONFIRM_MESSAGE = 'Are you sure you want to delete the selected document(s)? This action cannot be undone.';
export const BULK_DELETE_SUCCESS = 'Selected document(s) deleted successfully.';
export const BULK_DELETE_ERROR = 'Error deleting selected document(s).';
export const BULK_REDIRECT_CONFIRM_TITLE = 'Confirm Bulk Redirect';
export const BULK_REDIRECT_PROCESSING_TITLE = 'Redirecting...';
export const BULK_REDIRECT_COMPLETE_TITLE = 'Redirect Complete';
export const BULK_REDIRECT_SUCCESS = 'Selected document(s) redirected successfully.';
export const BULK_REDIRECT_ERROR = 'Error redirecting selected document(s).';
export const BULK_REDIRECT_PROCESSING_MESSAGE = 'Redirecting documents...';
export const UPLOAD_PROCESSING_TITLE = 'Uploading Documents';
export const UPLOAD_COMPLETE_TITLE = 'Upload Complete';
export const UPLOAD_PROCESSING_MESSAGE = 'Uploading documents...';
export const SALES_GROUP = "13f55c2f-c47a-48c5-a890-f1d34320f731";
export const RedirectReason_Junk = "a445d830-671b-44e2-9f11-0c9bcf764f5e";
export const ALREADY_LOCKED_ERROR = "Document is already locked by another user or unavailable.";
export const TODO_LIST_AUTOPROCESS_ERROR = "Could not start auto-processing. Please try again.";
export const TODO_AUTOPROCESS_START = 'Started Autoprocessing';
export const TODO_RELEASE_SUCCESS = 'All soft locked files have been released.';
export const TODO_RELEASE_ERROR = 'Unable to release locked files.';
export const TODO_UNLOCK_ERROR = 'Unable to release the processed document lock.'
export const AUTOPROCESS_CANNOT_PROCEED = 'Document processed, but unable to continue to the next document or return to the list.'

// Refi Module
export const DOCUMENT_NOT_FOUND = "Document not found."
export const REFI_APPROVAL_ERROR ="We encountered an issue while approving the document. Please try again in a moment. If the problem persists, contact support team for assistance."
export const DOCUMENT_FORM_VALIDATION_ERROR_MESSAGE = "Please check the highlighted fields."
export const CUSTOMER_NAME_MANDATORY_FIELDS_ERROR = "First & Last Name Or Company Name is required.";
export const CUSTOMER_NAME_MIN_LENGTH = "Field require 2 to 50 characters";
export const REQUESTOR_INVALID_EMAIL = "Specify a valid email";
export const MANDATORY_FIELDS = "Field cannot be blank";
export const CUSTOMER_ADDRESS1_MIN_LENGTH = "Field require 2 to 36 characters";
export const CUSTOMER_CITY_MIN_LENGTH = "Field require 2 to 23 characters";
export const ZIPCODE_INVALID_MESSAGE = "Field require 5 or 9 digits only";
export const DOCUMENT_APPROVED = 'This has been successfully approved and sent to Automated Processing.';
export const DOCUMENT_REJECTED = 'Document Rejected Successfully.';
export const DOCUMENT_REJECTED_ERROR = 'We encountered an issue while rejecting the document. Please try again in a moment. If the problem persists, contact support team for assistance.';
export const REJECT_EMAIL_SEND_ERROR = 'This has been rejected but failed to send the email confirmation.';
export const Warning_OnClickOfPopup_No = 'Document will remain locked, unable to continue approving.';

//Indexing/Processing Application ids
export const advRefNum = '101';
export const cs2RefNum = '100';
export const polRefNum = '100';
export const appCustType = 'cs2RefNum';
export const redirectReasonMandatory = '625fbc31-2fce-46ca-83dd-911e0b95c0ee';
export const redirectReasonOther = '0af9a56b-81ad-45f9-b9c1-5a35be7d1fe4';
// mandatory fields msgs for warning

export const INDEXING_UPDATE_MANDATORY = "Field cannot be blank";
export const Indexing_Term_Mandatory = 'Policy term selection is mandatory for indexing.';
export const Delete_Error_Message = 'Error on Delete.';
export const Error_On_Close = 'Error on Close.';
export const DocumentNotFoundError = ' The specified blob does not exist.';
export const UpdateErrorDocNotFound = 'This document is unavailable.  Please place this On Hold and contact the support team for assistance.';
export const UpdateErrorGeneric = 'Failed to Redirect Document.';
export const Restore_Error_Message = 'Error on Restore.';
export const RescanFolderId = 'bf52a1f7-ffc3-459d-ba6b-c19bbe657366';
export const NoPolicyFolderName = 'One Step';
export const ERROR_DOWNLOADING_DOCUMENT = 'Error downloading document:';
export const UNSUPPORTED_FILE_FORMAT = 'Unsupported File Format';
export const CANCEL = 'CANCEL';
export const DOWNLOAD = 'DOWNLOAD';
export const ALLOWED_UPLOAD_EXTENSIONS = new Set([
    'pdf',
    'doc',
    'docx',
    'docm',
    'xls',
    'xlsx',
    'xlsm',
    'ppt',
    'pptx',
    'jpg',
    'jpeg',
    'png',
    'gif',
    'tif',
    'tiff',
    'msg',
    'txt',
    'csv',
    'json',
    'svg',
    'html',
    'htm',
    'eml'
]);
export const UPLOAD_ACCEPT_ATTRIBUTE =
    '.pdf,.doc,.docx,.docm,.xls,.xlsx,.xlsm,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.tif,.tiff,.msg,.txt,.csv,.json,.svg,.html';
export const DELETE = 'DELETE';
export const DELETING = 'DELETING...';
export const DOC_NODE_TYPE_CATEGORY = 'category';
export const DOC_NODE_TYPE_FOLDER = 'folder';
export const MAX_UPLOAD_FILE_SIZE_MB = 29;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;
export const ALLOWED_UPLOAD_FILE_TYPES_LABEL =
    `* Allowed: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, GIF, TIFF, MSG, TXT, CSV, JSON, DOCM, XLSM, SVG, HTML.\n* Max size per document: ${MAX_UPLOAD_FILE_SIZE_MB} MB.`;

// Extensions the backend will convert to PDF for in-browser preview (Admin Documents viewer).
export const PREVIEWABLE_DOCUMENT_EXTENSIONS = new Set([
    'pdf',
    'doc',
    'docx',
    'rtf',
    'txt',
    'csv',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'jpg',
    'jpeg',
    'png',
    'tif',
    'tiff',
    'gif',
    'bmp',
    'msg',
    'eml'
]);

export const MAX_PREVIEW_SIZE_MB = 10;
export const MAX_PREVIEW_SIZE_BYTES = MAX_PREVIEW_SIZE_MB * 1024 * 1024;
export const UNSUPPORTED_FILE_FORMAT_MESSAGE = 'This file format is not supported for in-browser preview. Would you like to download it?';
export const PREVIEW_UNAVAILABLE_TITLE = 'Preview Unavailable';
export const PREVIEW_TOO_LARGE_MESSAGE = 'This file is too large to preview. Would you like to download it instead?';
export const PREVIEW_FAILED_MESSAGE = 'This document could not be displayed. Would you like to download it instead?';
export const OUTLOOK_MSG_MIME_TYPE = 'application/vnd.ms-outlook';
export const UPLOAD_DOCUMENT = 'Upload Document';
export const UPLOAD_FILES_TO = 'Upload Files to';
export const DESTINATION = 'Destination';
export const DOCUMENT_TYPE = 'Document Type';
export const DOCUMENT_TYPE_REQUIRED = 'Document type is required.';

// Folder creation
export const ADD_SUB_FOLDER = 'Add Sub-Folder';
export const FOLDER_NAME = 'Name';
export const FOLDER_NAME_PLACEHOLDER = 'Enter folder name';
export const FOLDER_NAME_REQUIRED = 'Folder name is required.';
export const FOLDER_NAME_EXISTS = 'A folder with this name already exists.';
export const FOLDER_NAME_MIN_LENGTH = 2;
export const FOLDER_NAME_MAX_LENGTH = 250;
export const FOLDER_NAME_TOO_SHORT = `Folder name must be at least ${FOLDER_NAME_MIN_LENGTH} characters.`;
export const FOLDER_NAME_TOO_LONG = `Folder name cannot exceed ${FOLDER_NAME_MAX_LENGTH} characters.`;
export const FOLDER_CREATED_SUCCESS = 'Folder created';
export const FOLDER_CREATION_ERROR = 'Failed to create folder. Please try again.';
export const CREATE = 'CREATE';
export const UNDER = 'under:';

// Folder rename
export const RENAME_SUB_FOLDER = 'Rename Sub-Folder';
export const CURRENT_NAME = 'Current Name';
export const NEW_NAME = 'New Name';
export const SAVE = 'SAVE';
export const FOLDER_RENAMED_SUCCESS = 'Folder renamed';
export const FOLDER_RENAME_ERROR = 'Failed to rename folder. Please try again.';
export const FOLDER_NOT_FOUND_ERROR = 'This folder no longer exists. Please refresh and try again.';
export const FOLDER_NAME_FORBIDDEN_CHARACTERS_PATTERN = /[%/\\[\]]/;
export const FOLDER_NAME_FORBIDDEN_CHARACTERS_MESSAGE = 'Folder names may contain letters, numbers, spaces, and , - & ‘ ( ) _ # @ + $ .; they cannot end with a dot or space.';
export const FOLDER_NAME_TRAILING_CHARACTERS_PATTERN = /[. ]$/;
export const FOLDER_NAME_TRAILING_CHARACTERS_MESSAGE = 'Folder name cannot end with a dot or space.';

// ── Admin Document row actions (kebab menu) ──
export const DOCUMENT_ACTIONS = 'Document actions';
export const ROW_ACTION_RENAME = 'Rename';
export const ROW_ACTION_REPLACE = 'Replace';
export const ROW_ACTION_DELETE = 'Delete';
export const ROW_ACTION_COMING_SOON = 'Coming soon';
export const DELETE_DOCUMENT_TITLE = 'Confirm Delete';
export const DELETE_DOCUMENT_WARNING = 'This document moves to the Admin Recycle Bin and can be restored for 30 days. The action is recorded in the audit log.';
export const DELETE_DOCUMENT_SUCCESS = 'Document deleted successfully.';
export const DELETE_DOCUMENT_ERROR = 'Error deleting the document. Please try again.';
export const DELETE_FOLDER_TITLE = 'Delete Folder';
export const DELETE_FOLDER_PROMPT = 'Delete';
export const DELETE_FOLDER_NOT_EMPTY = 'This folder is not empty.';
export const DELETE_FOLDER_ALSO_REMOVES = 'Deleting it also removes';
export const DELETE_FOLDER_DOCUMENTS_LABEL = 'document(s)';
export const FOLDER_ACTION_ADD = 'Add';
export const DELETE_FOLDER_CONFIRM_CHECKBOX = 'I understand this removes all contents.';
export const DELETE_FOLDER_WARNING = 'This folder and its contents will no longer be visible in DocuMate+. They are not permanently deleted\u2014 if you need them restored, contact the IT Department. The action is recorded in the audit log.';
export const DELETE_FOLDER_COUNT_ERROR = 'Error fetching folder document count. Please try again.';
export const DELETE_FOLDER_SUCCESS = 'Folder deleted successfully.';
export const DELETE_FOLDER_ERROR = 'Error deleting the folder. Please try again.';

// ── Admin Document breadcrumbs ──
export const ADD_NOTE_ERROR = 'Failed to add note.';
export const ADD_VIEW_NOTES = 'ADD/VIEW NOTES';
export const NEW_NOTE_LABEL = 'New Note';
export const NEW_NOTE_PLACEHOLDER = 'Add a note...';
export const SUBMIT = 'SUBMIT';
export const ADMIN_DOCUMENT_BREADCRUMBS = ['DocuMate+', 'Admin Documents'];
export const ADMIN_DOCUMENT_SEARCH_PLACEHOLDER = 'Search folders, files…';

// ── Admin Document search ──
export const SEARCH_MIN_LENGTH = 2;
export const SEARCH_MIN_LENGTH_MESSAGE = `Enter at least ${SEARCH_MIN_LENGTH} characters to search.`;
export const SEARCH_ALLOWED_PATTERN = /^[a-zA-Z0-9 ,.&'()_#@+$-]*$/;
export const SEARCH_DISALLOWED_CHARACTERS_PATTERN = /[^a-zA-Z0-9 ,.&'()_#@+$-]/g;
export const SEARCH_INVALID_CHARACTERS_MESSAGE = "Only letters, numbers, spaces, and these characters are allowed , - & ' ( ) _ # @ + $ and dot.";
export const SEARCH_RESULTS_TITLE = 'Search results';
export const SEARCH_FOLDERS_LABEL = 'Folders';
export const SEARCH_DOCUMENTS_LABEL = 'Documents';
export const SEARCH_NO_RESULTS = 'No matching folders or documents found.';
export const SEARCH_ERROR = 'Error running the search. Please try again.';
export const SEARCH_IN_PROGRESS = 'Searching…';
export const CLEAR_SEARCH = 'CLEAR';
export const SEARCH_RESULTS_FOR = 'Results for';
export const SEARCH_TAB_ALL = 'All';
export const DOCUMENT_GRID_DEFAULT_PAGE_SIZE = 10;
export const FOLDER_FILTER_PLACEHOLDER = 'Filter folders…';
export const DOCUMENT_FILTER_PLACEHOLDER = 'Filter documents...';
export const DOCUMENT_FILTER_NO_DOCUMENTS = 'There are no documents to filter.';
export const DOCUMENT_FILTER_NO_RESULTS = 'No matching documents found.';
export const FOLDER_FILTER_NO_RESULTS = 'No matching folders found.';
